module.exports = __webpack_public_path__ + "static/media/DSC07421 (1).9b86f406.jpg";